import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  meta: {
    title: '消息中心',
    auth: true,
    authorityValue: 'store-router-page'
  },
  name: 'news',
  data: function data() {
    return {
      newsList: [],
      total: 0,
      obj: {},
      unReadMessage: 0
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.d2admin.user.info;
    }
  },
  methods: {
    readAllMsg: function readAllMsg() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.readAllMsg();

              case 2:
                _this.newsList = [];

                _this.dataBind();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataBind: function dataBind(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, n;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.messages({
                  pageSize: 1000 * 1000
                });

              case 2:
                res = _context2.sent;
                _this2.total = res.total;
                n = res.records.reduce(function (l, i) {
                  if (i.relationType === 2) {
                    var inx = i.messageContent.indexOf('，原因');
                    i.messageContent = i.messageContent.slice(0, inx);
                  }

                  _this2.newsList.push(i);

                  return !i.messageRead ? l + 1 : l;
                }, 0);
                _this2.unReadMessage = n;

                _this2.$store.dispatch('d2admin/message/asyncMessage', n);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    openDetail: function openDetail(l) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log('l', l);

                if (l.messageRead) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 4;
                return _this3.$api.messageDetails({
                  messageId: l.messageId
                });

              case 4:
                data = _context7.sent;
                l.messageRead = data.messageRead;
                _this3.unReadMessage--;

                _this3.$store.dispatch('d2admin/message/asyncMessage', _this3.unReadMessage);

              case 8:
                if (l.relationType == 2) {
                  _this3.userInfo.positionAuthorities.forEach( /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              if (e.authorityValue == 'store-goods-management') {
                                if (e.active && e.children[1].active) {
                                  _this3.$router.push('/comsTrade');
                                }
                              }

                            case 1:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                }

                if (l.relationType == 1) {
                  _this3.userInfo.positionAuthorities.forEach( /*#__PURE__*/function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
                      return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              if (e.authorityValue == 'store-order-management') {
                                if (e.active && e.children[2].active) {
                                  _this3.$router.push('/orderSearch');
                                }
                              }

                            case 1:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));

                    return function (_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                }

                if (l.relationType == 4) {
                  _this3.userInfo.positionAuthorities.forEach( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(e) {
                      return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (e.authorityValue == 'store-goods-management') {
                                if (e.active && e.children[0].active) {
                                  _this3.$router.push('/saleTrade');
                                }
                              }

                            case 1:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                }

                if (l.relationType == 3) {
                  _this3.userInfo.positionAuthorities.forEach( /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e) {
                      return regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              if (e.authorityValue == 'store-financial-management') {
                                if (e.active && e.children[0].active) {
                                  _this3.$router.push('/wallet');
                                }
                              }

                            case 1:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));

                    return function (_x4) {
                      return _ref4.apply(this, arguments);
                    };
                  }());
                } // this.$alert(`${l.messageContent}`, l.messageTitle, {
                //   dangerouslyUseHTMLString: true
                // })


              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  },
  mounted: function mounted() {
    this.dataBind();
  }
};